import axios, { AxiosInstance } from "axios";
import { TransactionRuleEngineRepo, TransactionRuleEngineTesting, RuleSerializable } from "@framework/wallet-custody-domain/bin/rule-engine.js";
import { ContractDefinitionGeneric, ContractDefinitionServices, DLTProtocolEnum, TransactionDecoded } from "@framework/wallet-custody-domain/bin/blockchain.js";
import { TxMonitorRecord, TxMonitorServices } from "@framework/wallet-custody-domain/bin/wallet-custody.js";
import { handleError } from "./common.js";



export type { TxMonitorServices, TransactionRuleEngineTesting, ContractDefinitionServices, DLTProtocolEnum, RuleSerializable, TransactionDecoded, TransactionRuleEngineRepo, TxMonitorRecord, ContractDefinitionGeneric };



class ContractDefinitionServicesApi implements ContractDefinitionServices {
  constructor(private http: AxiosInstance, private chain: DLTProtocolEnum) {}

  async list(): Promise<ContractDefinitionGeneric[]> {
    try {
      const res = await this.http.get<ContractDefinitionGeneric[]>(`${this.chain}/definitions`)
      return res.data
    } catch (error) {
      handleError(error, "fail uploading the definitions file");
    }
  }
  
  get protocol(): DLTProtocolEnum {
    return this.chain;
  }
  async addFile(file: any): Promise<void> {
    try {
      const body = (typeof file == "string") ? {path: file} : {combined: file}
      await this.http.post(`${this.chain}/definitions`,body);
    } catch (error) {
      handleError(error, "fail uploading the definitions file");
    }
  }
  
}

class TxMonitorServicesApi implements TxMonitorServices {
  constructor(private http: AxiosInstance, private chain: DLTProtocolEnum) {}

  decodeSavedTransactions(): Promise<number> {
    throw new Error("Method not implemented over the REST api.");
  }


  async searchTransactions(filter: any): Promise<TxMonitorRecord[]> {
    try {
      const res = await this.http.request({
        method: "SEARCH" as any,
        url: `${this.chain}/txs`,
        data: filter
      })
      return res.data;
    } catch (error) {
      handleError(error, "fail search the transactions");
    }
  }
  
  get protocol(): DLTProtocolEnum {
    return this.chain;
  }

  
}

export class MonitoringServicesApi implements TransactionRuleEngineTesting, TransactionRuleEngineRepo {
  private http: AxiosInstance;
  constructor(protected baseUrl: string, protected chain: DLTProtocolEnum) {
    const base = new URL("api/monitoring", baseUrl);
    this.http = axios.create({
      baseURL: base.href,
      responseType: "json",
      validateStatus: (status) => status >= 200 && status <= 399,
    });
  }

  getDefinitionServices(chain: DLTProtocolEnum): ContractDefinitionServices {
    return new ContractDefinitionServicesApi(this.http, chain);
  }
  getTxMonitorServices(chain: DLTProtocolEnum): TxMonitorServices {
    return new TxMonitorServicesApi(this.http, chain);
  }
  
  async test(chain: DLTProtocolEnum, rules: RuleSerializable[], transaction: TransactionDecoded): Promise<any> {
    try {
      const res = await this.http.post(`test/rule`,{
        chain, rules, transaction
      })
      return res.data;
    } catch (error) {
      handleError(error, "fail executing the test");
    }
  }

  async load(chain: DLTProtocolEnum): Promise<RuleSerializable[]> {
    try {
      const res = await this.http.get(`${chain}/rules`)
      return res.data;
    } catch (error) {
      handleError(error, "fail getting the rules");
    }
  }
  async save(chain: DLTProtocolEnum, rule: RuleSerializable): Promise<RuleSerializable> {
    try {
      const res = await this.http.post(`${chain}/rules`, [rule])
      return Array.isArray(res.data) ? res.data.pop() : res.data;
    } catch (error) {
      handleError(error, "fail creating or updating the rule");
    }
  }
  async get(chain: DLTProtocolEnum, name: string): Promise<RuleSerializable | undefined> {
    try {
      const res = await this.http.get(`${chain}/rule/${name}`)
      return res.data;
    } catch (error) {
      handleError(error, "fail getting the rule");
    }
  }
  async delete(chain: DLTProtocolEnum, name: string): Promise<RuleSerializable> {
    try {
      const res = await this.http.delete(`${chain}/rule/${name}`)
      return res.data;
    } catch (error) {
      handleError(error, "fail deleting the rule");
    }
  }

}